// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  buttonProgress: {
    marginRight: '10px',
  },
  downloadText: {
    cursor: 'pointer',
    color: theme?.palette?.primary?.main,
  },
});

export default styles;
